var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg50Gold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 95.94204 60.4351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6.4351px;\n      }\n\n      .cls-2 {\n        fill: url(#Gold);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gold",
    x1: 47.97102,
    y1: 8.31469,
    x2: 47.97102,
    y2: 45.28912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00562,
    stopColor: "#fccb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25281,
    stopColor: "#fffad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29822,
    stopColor: "#faf1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38847,
    stopColor: "#edd894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51382,
    stopColor: "#d8b14c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59551,
    stopColor: "#c9961a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81418,
    stopColor: "#e9cd76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87079,
    stopColor: "#f2dc8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffad2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draw"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.70684,37.51949c3.52076,0,6.8907,2.39666,6.8907,6.21672a6.03209,6.03209,0,0,1-2.47129,4.868,11.9472,11.9472,0,0,0,5.09341,1.04869c6.21672,0,9.51125-5.692,9.51125-11.30934,0-5.46732-3.06987-10.78539-9.21275-10.78539-3.89311,0-5.3165,1.27335-7.1138,4.56867l-.22466.15H5.46418c0-10.186.22466-25.01535.22466-28.38529.60015.14925,10.56073.674,20.52288.674a111.37625,111.37625,0,0,0,16.402-.89865v.14925a18.2543,18.2543,0,0,1-.82481,2.322c-2.996,7.26462-13.6306,8.16406-21.42,8.16406-2.84521,0-5.31807-.07541-6.89071-.07541,0,.824-.07384,4.344-.07384,10.33606,3.5192-3.82006,7.26462-4.41942,12.35646-4.41942,11.08546,0,18.65016,6.1421,18.65016,17.376,0,13.40671-10.33606,19.47261-22.84334,19.47261-7.34,0-18.35009-2.846-18.35009-11.98333A7.23812,7.23812,0,0,1,10.70684,37.51949ZM71.82771,3.21755c16.402,0,20.89679,12.58191,20.89679,26.438,0,16.77666-4.94416,27.56205-22.02011,27.56205-18.49934,0-20.82138-16.028-20.82138-28.31066C49.883,15.05084,54.97642,3.21755,71.82771,3.21755Zm-6.29056,19.7719V40.06619c0,3.67.74782,9.51125,5.692,9.51125,4.26859,0,5.76739-3.44457,5.76739-9.212,0-6.66526.14925-11.75867.14925-17.30062,0-4.194-.07541-12.05874-5.61657-12.05874C66.88512,11.00612,65.53715,14.15219,65.53715,22.98945Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.70684,37.51949c3.52076,0,6.8907,2.39666,6.8907,6.21672a6.03209,6.03209,0,0,1-2.47129,4.868,11.9472,11.9472,0,0,0,5.09341,1.04869c6.21672,0,9.51125-5.692,9.51125-11.30934,0-5.46732-3.06987-10.78539-9.21275-10.78539-3.89311,0-5.3165,1.27335-7.1138,4.56867l-.22466.15H5.46418c0-10.186.22466-25.01535.22466-28.38529.60015.14925,10.56073.674,20.52288.674a111.37625,111.37625,0,0,0,16.402-.89865v.14925a18.2543,18.2543,0,0,1-.82481,2.322c-2.996,7.26462-13.6306,8.16406-21.42,8.16406-2.84521,0-5.31807-.07541-6.89071-.07541,0,.824-.07384,4.344-.07384,10.33606,3.5192-3.82006,7.26462-4.41942,12.35646-4.41942,11.08546,0,18.65016,6.1421,18.65016,17.376,0,13.40671-10.33606,19.47261-22.84334,19.47261-7.34,0-18.35009-2.846-18.35009-11.98333A7.23812,7.23812,0,0,1,10.70684,37.51949ZM71.82771,3.21755c16.402,0,20.89679,12.58191,20.89679,26.438,0,16.77666-4.94416,27.56205-22.02011,27.56205-18.49934,0-20.82138-16.028-20.82138-28.31066C49.883,15.05084,54.97642,3.21755,71.82771,3.21755Zm-6.29056,19.7719V40.06619c0,3.67.74782,9.51125,5.692,9.51125,4.26859,0,5.76739-3.44457,5.76739-9.212,0-6.66526.14925-11.75867.14925-17.30062,0-4.194-.07541-12.05874-5.61657-12.05874C66.88512,11.00612,65.53715,14.15219,65.53715,22.98945Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg50Gold);
export default __webpack_public_path__ + "static/media/50-gold.76d34542f244c8f4ba6d70724b903efc.svg";
export { ForwardRef as ReactComponent };